import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import ListCreator from '../../components/Lists/listCreator'
import { getCall } from '../helpers/componentApiHelpers/getCall'
import '../main.css'

class BoyutlarList extends Component {

    constructor(props){
        super(props)
        this.state = {
            data: "",
            dataCame: false
        }
    }

    async componentDidMount() {
        try{
            const getData = await getCall("/color/getall")
            await this.setState({dataCame: true, data: getData.data})
        }
        catch(err){
            console.log(err)
        }
    }

    render() {

        return (
            <React.Fragment>
                <HeaderLine header="Renkler" />
                <button onClick={() => this.props.history.push("/renkCreate")} className="blue-button add-new-button">Yeni Ekle</button>
                <ListCreator
                    data={this.state.data}
                    dataInfo={[
                        { className: "col-3 col-md-3 col-sm-3 col-lg-3", objectPropName: "color", color: true, header: "Renk Kodu" },
                        { className: "col-3 col-md-3 col-sm-3 col-lg-3", objectPropName: "colorName", color: true, header: "Renk İsmi" },
                    ]}
                    buttons={{
                        className: "col-2",
                        buttonData: [
                            { name: "Düzenle", func: (d) => {this.props.history.push("/renkCreate/" + d._id)} },
                            { name: "Detay", func: (d) => {this.props.history.push("detay/renkDetay/" + d._id)} },
                            { name: "Sil" }
                        ]
                    }}
                    dataCame={this.state.dataCame}
                    endPoint="/color"
                />
            </React.Fragment>
        )
    }
}

export default BoyutlarList